export default {
  // Tabs
  customModelsTab: 'Modelos Personalizados',
  adHocModelsTab: 'Modelos Ad-Hoc',
  automaticModelsTab: 'Modelos DIY',
  metadataTab: 'Metadatos',
  channelTaxonomyTab: 'Taxonomía de Canales',
  deletedModelsTab: 'Modelos eliminados',
  errorDeletingModel: 'Error al eliminar el modelo',
  errorDeletingSomeModels: 'No se pudieron eliminar {count} modelos',

  // Delete selected models dialog
  deleteSelectedTitle: '¿Eliminar los modelos seleccionados?',
  deleteSelectedMessage: 'Estás a punto de eliminar los siguientes ({count}) modelos:',
  deleteSelectedConfirm: '¿Estás seguro?',
  deleteSelectedWarning: 'Podrás recuperarlos durante 7 días solicitándolo a un administrador.',
  deleteSelectedInputLabel: "escribe 'delete' aquí para habilitar el botón Eliminar Modelos",
  deleteModelsButton: 'Eliminar modelos',

  // Delete single model dialog
  warningTitle: 'Advertencia',
  deleteModelMessage: 'Eliminando modelo: {name}',
  deleteModelConfirm: 'Podrás recuperarlo durante 7 días solicitándolo a un administrador. ¿Estás seguro?',

  // Buttons
  createCustomModel: 'Crear Modelo Personalizado',
  deleteSelectedModels: 'Eliminar modelos seleccionados',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  close: 'Cerrar',

  // Search
  search: 'Buscar',

  // Custom Models table headers
  headerName: 'Nombre',
  headerType: 'Tipo',
  headerCategory: 'Categoría',
  headerReference: 'Referencia',
  headerMonthlySpend: 'Gasto',
  headerMonthlySales: 'Ventas',
  headerCountry: 'País',
  headerQuality: 'Calidad',
  headerModified: 'Modificado',
  headerCreator: 'Creador',
  headerActions: 'Acciones',

  // Edit name
  editLabel: 'Editar',
  inputTooLong: '¡Entrada demasiado larga!',

  // Action tooltips
  recalculateModelReport: 'Recalcular Reporte del Modelo',
  clone: 'Clonar',
  deleteModel: 'Eliminar Modelo',
  printJsonToConsole: 'Imprimir JSON en consola',
  importPlans: 'Importar Planes',
  modelSettings: 'Configuración del Modelo',
  modelData: 'Datos del Modelo',

  // Snackbar messages
  modelRenamed: 'Modelo renombrado',
  errorRenamingModel: 'Error al renombrar el modelo',
  idCopied: '¡ID copiado al portapapeles!',

  // Model type labels (Metadata tab)
  typeCustomReference: 'Personalizado Ref.',
  typeCustomEkrm: 'Personalizado EKRM',
  typeAdHoc: 'Ad-Hoc',
  typeDiy: 'DIY',

  // Type column filter (Metadata tab)
  filterSelectAll: 'Seleccionar todo',
  filterNone: '(ninguno)',

  // Client-metadata columns (Metadata tab)
  metaHeaderClient: 'Cliente',
  metaHeaderBrand: 'Marca',
  metaHeaderCategory: 'Categoría',
  metaHeaderSubCategory: 'Subcategoría',
  metaHeaderCountry: 'País',

  // Channel Taxonomy tab
  taxonomyHeaderModel: 'Modelo',
  taxonomyHeaderChannel: 'Canal',
  taxonomyHeaderCode: 'Taxonomía',
  taxonomyExportCsv: 'Exportar CSV',
  taxonomyCodeCopied: '¡Código de taxonomía copiado al portapapeles!',

  // Ad-Hoc tab filters
  selectAllVisible: 'Seleccionar Todos los Visibles ({count})',
  allCountries: 'Todos los países',
  countriesSelected: '{count} de {total} países seleccionados',
  filterByCountry: 'Filtrar por País',
  searchCountries: 'Buscar países',
  allBrands: 'Todas las marcas',
  brandsSelected: '{count} de {total} marcas seleccionadas',
  filterByBrand: 'Filtrar por Marca',
  searchBrands: 'Buscar marcas',
  allClients: 'Todos los clientes',
  clientsSelected: '{count} de {total} clientes seleccionados',
  filterByClient: 'Filtrar por Cliente',
  searchClients: 'Buscar clientes',
  allCategories: 'Todas las categorías',
  categoriesSelected: '{count} de {total} categorías seleccionadas',
  filterByCategory: 'Filtrar por Categoría',
  searchCategories: 'Buscar categorías',
  allSubcategories: 'Todas las subcategorías',
  subcategoriesSelected: '{count} de {total} subcategorías seleccionadas',
  filterBySubcategory: 'Filtrar por Subcategoría',
  searchSubcategories: 'Buscar subcategorías',

  // Misc
  notAvailable: 'N/D',
  updating: '(Actualizando...)',
  // Versions
  current: 'actual',
  versionDeployed: 'Desplegada el {date}'
}
